import "./count-preview.scss";
import BoxContent from "../../BoxContent";
import { useDocsOfUser } from "../../../statistics/hooks/use-doc-of-user";
import { useHistory } from "react-router-dom";

const CountDocumentPreview = () => {
  const { countInternalDocument, countExternalDocument, countPublishedDocument } = useDocsOfUser();
  const history = useHistory();

  return (
    <div className="count-preview">
      <BoxContent color="success" background="bg-user" onClick={() => history.push("/document?status=publish")}>
        <BoxContent.Icon src="/assets/images/composing-document.png" />
        <BoxContent.Right>
          <BoxContent.Label>Tài liệu ban hành</BoxContent.Label>
          <BoxContent.Count value={countPublishedDocument || 0} />
        </BoxContent.Right>
      </BoxContent>

      <BoxContent color="info" background="bg-user" onClick={() => history.push("/document?status=publish")}>
        <BoxContent.Icon src="/assets/images/internal-document.png" />
        <BoxContent.Right>
          <BoxContent.Label>Tài liệu bên ngoài</BoxContent.Label>
          <BoxContent.Count value={countExternalDocument || 0} />
        </BoxContent.Right>
      </BoxContent>

      <BoxContent color="danger" background="bg-user" onClick={() => history.push("/document?status=publish")} style={{ width: "100%" }}>
        <BoxContent.Icon src="/assets/images/external-document.png" />
        <BoxContent.Right>
          <BoxContent.Label>Tài liệu nội bộ</BoxContent.Label>
          <BoxContent.Count value={countInternalDocument || 0} />
        </BoxContent.Right>
      </BoxContent>
    </div>
  );
};

export default CountDocumentPreview;
